import { CHAMP_REQUIS, MESSAGE_ERROR_HEURES_DOIVENT_ETRE_A_0 } from "utils/constantes";
import { z, ZodErrorMap } from "zod";

export const dateFormat = "dd/MM/yyyy";
export const dateFormatShort = "MM/yyyy";
export const VALEUR_NON_DEFINI = "N/A";
export const NA_FOR_ENUM = "NA";

export const required = { required_error: CHAMP_REQUIS };

export const requiredEnum: { errorMap?: ZodErrorMap } = {
  errorMap: (issue, ctx) => {
    if (issue.code === "invalid_enum_value")
      return {
        message: `La valeur reçu "${
          issue.received
        }" est invalide. Le format attendu est ${issue.options.join(" ou ")}`,
      };

    if (issue.code === "invalid_type") return { message: required["required_error"] };

    return { message: ctx.defaultError };
  },
};

export const civiliteEnum = ["MR", "MM", "ML", NA_FOR_ENUM] as const;
export const labelsCivilite = {
  MR: "Monsieur",
  MM: "Madame",
  ML: "Mademoiselle",
} as const;

export const zCivilite = z.enum(civiliteEnum, requiredEnum);

const statutContrat = ["Tous", "C", "R"] as const;
export const labelsStatutContrat = {
  C: "En Cours",
  R: "Cloturé",
};

export const zStatutContrat = z.enum(statutContrat, requiredEnum);
export const zOpearation = z.enum(["I", "R"], requiredEnum);

const origineResiliationEnum = [
  "NC",
  "NP",
  "AS",
  "AU",
  "FA",
  "FS",
  "IP",
  "IR",
  "AR",
  "OC",
  "PS",
] as const;
export const labelsOrigineResiliation = {
  NC: "Nullité Contrat",
  NP: "Non Paiement",
  AS: "Après Sinistre",
  AU: "Autres",
  FA: "Du fait Assure",
  FS: "Fréquence de sinistres",
  IP: "Fréquence incidents de paiement",
  IR: "Inadéquation du risque",
  AR: "Changement de politique d'acceptation des risques",
  OC: "Non respect des obligations contractuelles",
  PS: "Perte de qualité societaire",
  NA: "",
};

export const canalEnum = ["Tous", "WS", "PORTAIL"] as const;

export const typeInterrosEnum = [
  "Tous",
  "INTERROGATION_CONFORMITE",
  "INTERROGATION_INFORMATION_PARTICULIER",
  "INTERROGATION_INFORMATION_SOCIETE",
] as const;
export const typeInterrosLabels = {
  Tous: "Tous",
  INTERROGATION_CONFORMITE: "Interrogation Conformité",
  // INTERROGATION_INFORMATION_PARTICULIER: "Interrogation Paticulier",
  // INTERROGATION_INFORMATION_SOCIETE: "Interrogation Société",
};

export const typeAlimEnum = [
  "Tous",
  "ALIMENTATION_RIE",
  "ALIMENTATION_CRM",
  "ALIMENTATION_HABILITATION",
] as const;

export const statutFileEnum = ["Tous", "EN_ATTENTE", "EN_COURS", "TERMINE", "EN_ERREUR"] as const;
export const statutFileLabels = {
  Tous: "Tous",
  EN_ATTENTE: "En attente",
  EN_COURS: "En cours",
  TERMINE: "Terminé",
  EN_ERREUR: "En erreur",
};

export const zOrigineResiliation = z.enum(origineResiliationEnum, requiredEnum);

export const USAGE_ENUM = ["T", "D", NA_FOR_ENUM] as const;
export const labelUsage = {
  T: "Usage tournées",
  D: "Usage tous déplacements",
};
export const zUsageVehicule = z.enum(USAGE_ENUM, requiredEnum);
export const zMotifAlimentation = z.enum(["A", "E", "T"], requiredEnum);

export const labelTypeConducteur = {
  P: "Principal",
  S: "Secondaire",
  O: "Occasionnel",
  D: "Non désigné",
  I: "Indéterminé",
};

export const zTypeConducteur = z.enum(["P", "S", "O", "D", "I"], requiredEnum);
export const labelNatureSinistre = {
  M: "Matériel",
  C: "Corporel",
};
export const labelLanguePDF = {
  FR: "Français",
  EN: "English",
};
export const zNatureSinitre = z.enum(["M", "C"], requiredEnum);

export enum PrecisionSinistreEnum {
    AC = "AC",
    ST = "ST",
    BG = "BG",
    EC = "EC",
    IN = "IN",
    VL = "VL",
    VA = "VA",
    AU = "AU",
}

export const labelsPrecisionSinistre = {
  AC: "AC",
  ST: "ST",
  BG: "BG",
  EC: "EC",
  IN: "IN",
  VL: "VL",
  VA: "VA",
  AU: "AU",
};

export enum PrecisionSinistreAltEnum {
    VOL = "VOL",
    IN = "IN",
    INCD = "INCD",
    INI = "INI",
    EXP = "EXP",
    IM = "IM",
    BG = "BG",
    BGRP = "BGRP",
    BGSP = "BGSP",
    AUTRE = "AUTRE",
    A = "A",
    B = "B",
    C = "C",
    D = "D",
    D1 = "D1",
    D2 = "D2",
    D3 = "D3",
    D4 = "D4",
    E = "E",
    E1 = "E1",
    E2 = "E2",
    E3 = "E3",
    E4 = "E4",
    F = "F",
    F5 = "F5",
    F6 = "F6",
    H = "H",
    H5 = "H5",
    H6 = "H6",
    H7 = "H7",
    H8 = "H8",
    I = "I",
    I5 = "I5",
    I6 = "I6",
    I7 = "I7",
    J = "J",
    K = "K",
    L = "L",
    P = "P",
    P9 = "P9",
    PA = "PA",
    PB = "PB",
    PC = "PC",
    PD = "PD",
    PE = "PE",
    PF = "PF",
    R = "R",
    S = "S",
    S1 = "S1",
    S2 = "S2",
    S3 = "S3",
    S4 = "S4",
    S5 = "S5",
    S6 = "S6",
    S7 = "S7",
    S8 = "S8",
    S9 = "S9",
    IND = "IND"
}

export const zPrecisionSinistre = z.enum(["AC", "ST", "BG", "EC", "IN", "VL", "VA", "AU"]);
export const zPrecisionSinistreAlt = z.enum(
  [
    "VOL",
    "IN",
    "INCD",
    "INI",
    "EXP",
    "IM",
    "BG",
    "BGRP",
    "BGSP",
    "AUTRE",
    "A",
    "B",
    "C",
    "D",
    "D1",
    "D2",
    "D3",
    "D4",
    "E",
    "E1",
    "E2",
    "E3",
    "E4",
    "F",
    "F5",
    "F6",
    "H",
    "H5",
    "H6",
    "H7",
    "H8",
    "I",
    "I5",
    "I6",
    "I7",
    "J",
    "K",
    "L",
    "P",
    "P9",
    "PA",
    "PB",
    "PC",
    "PD",
    "PE",
    "PF",
    "R",
    "S",
    "S1",
    "S2",
    "S3",
    "S4",
    "S5",
    "S6",
    "S7",
    "S8",
    "S9",
    "IND",
  ]
);

export const toPrecisionSinistreCode = (code?: PrecisionSinistreAltEnum): PrecisionSinistreEnum => {
  switch (code) {
    case "A":
    case "VOL":
    case "F":
    case "F5":
    case "F6":
    case "H":
    case "H5":
    case "H6":
    case "H7":
    case "H8":
    case "I":
    case "I5":
    case "I6":
    case "I7":
      return PrecisionSinistreEnum.VL; // Vols

    case "J":
      return PrecisionSinistreEnum.VL; // Vandalisme

    case "D":
    case "D2":
    case "D3":
    case "D4":
      return PrecisionSinistreEnum.AC; // Circulation

    case "C":
      return PrecisionSinistreEnum.EC; // Dommages matériels

    case "E":
    case "E1":
    case "E2":
    case "E3":
    case "E4":
      return PrecisionSinistreEnum.ST; // Stationnement / Assistance selon ton mapping métier

    case "BG":
    case "BGSP":
    case "BGRP":
      return PrecisionSinistreEnum.BG; // Bris de glace

    case "IN":
    case "EXP":
    case "INI":
    case "INCD":
    case "K":
      return PrecisionSinistreEnum.IN; // Incendie

    case "IND":
    default:
      return PrecisionSinistreEnum.AU; // Indéterminé
  }
};

export const labelPartResponsabilite = {
  N: "Nulle",
  T: "Totale",
  P: "Partielle",
  I: "Inconnue",
};
export const zPartResponsabilite = z.enum(["N", "T", "P", "I"], requiredEnum);

export const zDateHours0 = z.coerce.date(required).refine(
  (date) => {
    const hours = date?.getHours();
    const min = date?.getMinutes();
    const sec = date?.getSeconds();
    return hours === 0 && min === 0 && sec === 0;
  },
  { message: MESSAGE_ERROR_HEURES_DOIVENT_ETRE_A_0 }
);

export enum EtatAlerteEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  Tous = "Tous",
}

export const etatAlerteEnum = [EtatAlerteEnum.Tous, EtatAlerteEnum.ACTIVE, EtatAlerteEnum.INACTIVE] as const;
export const zEtatAlertes = z.enum(etatAlerteEnum, requiredEnum);

export enum StatutAlerteEnum {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  Tous = "Tous",
}
export const statutAlerteEnum = [StatutAlerteEnum.Tous, StatutAlerteEnum.ACTIVE, StatutAlerteEnum.INACTIVE] as const;
export const zStatutAlerte = z.enum(statutAlerteEnum, requiredEnum);

export const codeAlerteEnum = ["Tous", "PBDELAI", "INTINCG", "INTINCS", "INTRESG", "INTRESS", "NPFVA", "RIPAR"] as const;
export const zCodeAlerte = z.enum(codeAlerteEnum, requiredEnum);

export enum TypeFrequenceEnum {
  Tous = "Tous",
  RIE_ALERTE = "RIE_ALERTE",
  RIE_MOUVEMENT_ALERTE = "RIE_MOUVEMENT_ALERTE",
  RIE_REJETS = "RIE_REJETS",
  RIE_PARC = "RIE_PARC",
  RIE_HABILITATION_INTERMEDIAIRE = "RIE_HABILITATION_INTERMEDIAIRE",
  RIE_LIST_INTERMEDIAIRE_HABILETE = "RIE_LIST_INTERMEDIAIRE_HABILETE",
  RIE_LIST_INTERMEDIAIRE = "RIE_LIST_INTERMEDIAIRE",
  RIE_MOUVEMENT_PARC = "RIE_MOUVEMENT_PARC"
}

export enum TypeFrequenceAssuEnum {
  Tous = "Tous",
  RIE_ALERTE = "RIE_ALERTE",
  RIE_MOUVEMENT_ALERTE = "RIE_MOUVEMENT_ALERTE",
  RIE_REJETS = "RIE_REJETS",
  RIE_PARC = "RIE_PARC",
  RIE_LIST_INTERMEDIAIRE_HABILETE = "RIE_LIST_INTERMEDIAIRE_HABILETE",
  RIE_LIST_INTERMEDIAIRE = "RIE_LIST_INTERMEDIAIRE",
  RIE_MOUVEMENT_PARC = "RIE_MOUVEMENT_PARC"
}

export enum TypeFrequenceIntEnum {
  Tous = "Tous",
  RIE_ALERTE = "RIE_ALERTE",
  RIE_MOUVEMENT_ALERTE = "RIE_MOUVEMENT_ALERTE",
  RIE_REJETS = "RIE_REJETS",
  RIE_PARC = "RIE_PARC",
  RIE_HABILITATION_INTERMEDIAIRE = "RIE_HABILITATION_INTERMEDIAIRE",
  RIE_LIST_INTERMEDIAIRE = "RIE_LIST_INTERMEDIAIRE",
  RIE_MOUVEMENT_PARC = "RIE_MOUVEMENT_PARC"
}
export const typeFrequenceEnum = [TypeFrequenceEnum.Tous, TypeFrequenceEnum.RIE_ALERTE, TypeFrequenceEnum.RIE_MOUVEMENT_ALERTE, TypeFrequenceEnum.RIE_REJETS, TypeFrequenceEnum.RIE_PARC, TypeFrequenceEnum.RIE_HABILITATION_INTERMEDIAIRE, TypeFrequenceEnum.RIE_LIST_INTERMEDIAIRE_HABILETE, TypeFrequenceEnum.RIE_LIST_INTERMEDIAIRE, TypeFrequenceEnum.RIE_MOUVEMENT_PARC] as const;

export const labelSynchroFva = {
  Tous: "tous",
  true: "oui",
  false: "non"
} as const;
